<!--
================================================
Un composant permettant de choisir le type de rapport à afficher : résumé/détaillé

Url d'accès : http://localhost:8080/fr/cronocloud-inc/reports

================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
<!--    <div id="ReportTypeSelector">-->
<!--        {{'Hello ! :) I am ' + $options.name}}-->
<!--    </div>-->

    <div class="tabs is-right is-boxed" id="ReportTypeSelectorComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}">
        <ul class="has-text-weight-bold">
            <li v-bind:class="{'is-active':$route.params.reportType == 'summary'}" class="summaryTab" v-on:click="emitReportType('summary')">
                <router-link v-bind:to="{ name: 'reports', params:{'reportType': 'summary',
                  'startDate':$route.params.startDate,'endDate':$route.params.endDate
                }}" >
                        <font-awesome-icon class="icon" :icon="['fas', 'chart-pie']"/>
                        {{ $t("résumé") }}
                </router-link>
            </li>

            <li v-bind:class="{'is-active':$route.params.reportType  == 'detailed'}" class="detailedTab" v-on:click="emitReportType('detailed')">
                <router-link v-bind:to="{ name: 'reports', params:{'reportType': 'detailed',                                'startDate':$route.params.startDate,'endDate':$route.params.endDate
               }}">
                        <font-awesome-icon class="icon" :icon="['fas', 'tasks']"/>
                        {{ $t("détaillé") }}
                </router-link>
            </li>

        </ul>
    </div>


    <!--    https://www.npmjs.com/package/v-click-outside-->
<!--    <div v-click-outside="onClickOutside"></div> -->
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
    import {mapState} from 'vuex'
    import SentryMixin from "../../mixins/SentryMixin.js";
    // import SpinnerLoaderComp from "./SpinnerLoaderComp.vue";
    import GlobalErrorNotification from "../../mixins/GlobalErrorNotificationMixin.js";
    import InterceptorMixin from "../../mixins/InterceptorMixin.js";
    // import _ from 'lodash'

    // import vClickOutside from 'v-click-outside'

    export default {
        name: 'ReportTypeSelector', //utile dans vue dev tool
        mixins: [GlobalErrorNotification, SentryMixin, InterceptorMixin],
        // components: {},

        // props: {
        // },
        data: function () {
            return {
                // locale : this.$route.params.locale
                reportType : this.$route.params.reportType
                // pour les composants où l'user est identifié ///////////////////////
                // organizationSlug: this.$route.params.organization
                // userSlug: JSON.parse(this.$cookie.get('auth')).userSlug
                // componentIsReady : false, // indique quand le composant est prêt à être affiché
                // =================================================================
            }
        },

        computed:{
            // computed props for store :
            ...mapState({
                // user: state => state.user
                themeToDisplay: state => state.app.themeToDisplay
            }),


        },
        // watch: {
        // },

        methods: {
            emitReportType: function(type){
                this.$root.$emit('report_type_required', type)
            },
        },

        // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
        mounted: function () {

            if(this.reportType==null){
                this.reportType="summary"
            }

        }
    }
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "../../assets/css/globalVar";
    /*@import "../assets/css/bulmaResponsiveDep.scss";*/

    #ReportTypeSelectorComp{
      .is-active{
        color:$brandSecondary !important;
      }
      //////////////////////////////////////
      // DARK UI ///////////////////////////
      &.darkMode {

      }

    }

</style>
